// Both imported by module path rather than through their feature barrels: these
// barrels sit in long import cycles, and this hook runs on every analytics query.
import { useAccountStore } from "@/features/account-management/store/account.store";
import { useAnalyticsStore } from "../store/analytics.store";

/**
 * Whether the page should serve placeholder (demo) analytics.
 *
 * `demo: true` makes the backend return a canned dataset and ignore every
 * filter, so a HubSpot deep link into a placeholder-enabled account could only
 * ever show the generic dashboard. A link that names a story/version is asking
 * for that version's real numbers, so it opts out of placeholder data — and the
 * "you're looking at sample data" note has to follow the same rule, or it
 * contradicts what is on screen.
 */
export const useShowPlaceholderData = () => {
  const showAnalyticsPlaceholder = useAccountStore(
    (s) => s.showAnalyticsPlaceholder,
  );
  const isDeepLink = useAnalyticsStore((s) => s.isDeepLink);
  return showAnalyticsPlaceholder && !isDeepLink;
};
